<template>
  <div>
    <div v-if="loader == true">
      <vue-loaders
        name="line-spin-fade-loader"
        color="black"
        scale="1"
      ></vue-loaders>
      Preparing data for download MDA Civil Servants
    </div>
    <div v-else>
      <p class="alert alert-warning">
        <download-excel
          :data="json_data"
          :fields="json_fields"
          name="facilities.xls"
        >
          Download Data for Health Providers
          <!-- <img src="download_icon.png" /> -->
        </download-excel>
      </p>
    </div>
    <!-- {
            loader == true ? <vue-loaders name="line-spin-fade-loader" color="black" scale="1"></vue-loaders>:
        } -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      loader: true,
      json_fields: {
        "Facility Name": "agency_name",
        "Contact First Name": "firstname",
        "Contact Last Name": "lastname",
        "Contact Number": "phone_number",
        Email: "email",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      json_data: [],
    };
  },
  mounted() {
    this.downloadData();
  },
  methods: {
    downloadData() {
      this.axios
        .get(`/api/v1/auth/providerAgency/4`)
        .then((response) => {
          // console.log(response.data);
          this.json_data = response.data.data;
          this.loader = false;
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>
